import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { Fragment } from "react";

const AssignedByListBox = ({
    label = "Assigned by",
    employees,
    assignedBy,
    onChange,
    isError = false, // ✅ Valor por defecto
}) => {
    const displayValue = (assignedBy) => {
        if (assignedBy !== null) {
            if (assignedBy.fullName !== undefined) {
                return assignedBy.fullName;
            }
            return assignedBy.firstName + " " + assignedBy.lastName;
        }
        return "";
    };

    return (
        <div className="mt-5 sm:mt-6">
            <label
                htmlFor="assignedBy"
                className="block text-sm font-medium text-left text-gray-700"
            >
                {label} <span className="text-red-500">*</span>
            </label>
            <Listbox
                by="employeeId"
                as="div"
                className="relative inline-block w-full text-left"
                value={assignedBy}
                onChange={onChange}
            >
                <div>
                    <Listbox.Button
                        className={`inline-flex truncate justify-between w-full rounded-md px-3 py-2 text-sm font-normal text-gray-700 shadow-sm focus:outline-none focus:ring-0 ${
                            isError
                                ? "border border-red-500"
                                : "border border-gray-200"
                        } bg-white hover:bg-gray-50`}
                    >
                        <span>
                            {assignedBy !== null
                                ? displayValue(assignedBy)
                                : "Not Assigned"}
                        </span>
                        <ChevronUpDownIcon className="w-5 h-5" aria-hidden="true" />
                    </Listbox.Button>
                </div>

                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Listbox.Options className="right-0 z-10 w-full mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <ul className="w-full py-1 overflow-auto max-h-72">
                            {employees.map((employee) => (
                                <Listbox.Option
                                    name="assignedByEmployee"
                                    key={employee.employeeId}
                                    value={employee}
                                    className="m-5 cursor-pointer"
                                >
                                    {({ active, selected }) => (
                                        <div
                                            className={`${
                                                active
                                                    ? "text-white bg-blue-600"
                                                    : "text-gray-900"
                                            } cursor-pointer select-none relative pl-8 pr-4`}
                                        >
                                            {selected && (
                                                <span
                                                    className={`${
                                                        active
                                                            ? "text-white"
                                                            : "text-blue-600"
                                                    } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                                >
                                                    <CheckIcon className="w-5 h-5 text-green-600" />
                                                </span>
                                            )}
                                            <span
                                                className={`${
                                                    selected
                                                        ? "font-semibold"
                                                        : "font-normal"
                                                } block truncate`}
                                            >
                                                {employee.firstName +
                                                    " " +
                                                    employee.lastName}
                                            </span>
                                        </div>
                                    )}
                                </Listbox.Option>
                            ))}
                        </ul>
                    </Listbox.Options>
                </Transition>
            </Listbox>
        </div>
    );
};

export default AssignedByListBox;
